import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { styled } from '@stitches/react';
import ProductsOverview from './ProductsOverview';
import CloudMining from './cloudmining/CloudMining';
import MiningHotel from './mininghotel/MiningHotel';
import AsicShop from './asicshop/AsicShop';
import NftFarm from './nftfarm/NftFarm';
import KipaWallet from './kipawallet/KipaWallet';

// 产品页面容器样式
const ProductsContainer = styled('div', {
  width: '100%',
  minHeight: '100vh',
  padding: '2rem 0',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'var(--surface-color)',
  color: 'var(--text-primary)'
});

/**
 * 产品页面组件
 * 包含产品概览和各子产品模块的路由
 */
const ProductsPage: React.FC = () => {
  // const { t } = useTranslation(); // 暂时未使用
  
  return (
    <ProductsContainer>
      <Routes>
        {/* 产品概览页面 */}
        <Route index element={<ProductsOverview />} />
        
        {/* 云挖矿子模块 */}
        <Route path="cloud-mining/*" element={<CloudMining />} />
        
        {/* 矿机托管子模块 */}
        <Route path="mining-hotel/*" element={<MiningHotel />} />
        
        {/* ASIC矿机商店子模块 */}
        <Route path="asic-shop/*" element={<AsicShop />} />
        
        {/* NFT矿场子模块 */}
        <Route path="nft-farm/*" element={<NftFarm />} />
        
        {/* Kipa钱包子模块 */}
        <Route path="kipa-wallet/*" element={<KipaWallet />} />
        
        {/* 重定向到产品概览 */}
        <Route path="*" element={<Navigate to="/products" replace />} /> 
      </Routes>
    </ProductsContainer>
  );
};

export default ProductsPage; 